import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function MainLayout() {
  const location = useLocation();

  const hideLayout = location.pathname.startsWith("/card");

  return (
    <>
      {!hideLayout && <Header />}

      <main>
        <Outlet />
      </main>

      {!hideLayout && <Footer />}
    </>
  );
}
